import { invokeSowAgent } from "@/graphql/queries";
import { onSowAgentResponse } from "@/graphql/subscriptions";
import { MODEL_KEYS, resolveModelKey } from "@/constants/modelRegistry";
import { PROCESS_STATUS, SOW_PROCESS_TIMEOUT_MS } from "@/store/subscriptionCore/processConstants";
import { invokeAndSubscribe } from "@/store/subscriptionCore/subscriptionApi";

/**
 * @param {Object} params
 * @param {string} params.message
 * @param {string} params.modelSelection
 * @param {string} params.userId
 * @param {string} params.customerId
 * @param {string|null} [params.propertyId]
 * @param {string|null} [params.strategyName]
 * @param {Object} context
 * @returns {Promise<Object>}
 */
export async function runSowProcess(params, context) {
  const { message, modelSelection, userId, customerId, propertyId = null, strategyName = null } = params;
  const resolvedModelSelection = resolveModelKey(modelSelection, MODEL_KEYS.GPT_5_4_MINI);
  context.setProgress({ status: PROCESS_STATUS.INVOKING, message: "Starting SOW agent..." });

  const { correlationId, payload } = await invokeAndSubscribe({
    invokeQuery: invokeSowAgent,
    invokeVariables: {
      message,
      model_selection: resolvedModelSelection,
      user_id: userId,
      customer: customerId,
      property_id: propertyId,
      strategy_name: strategyName,
    },
    invokeResultPath: "data.invokeSowAgent",
    subscriptionQuery: onSowAgentResponse,
    processTag: "SOW",
    timeoutMs: SOW_PROCESS_TIMEOUT_MS,
    isProcessingEvent: (event) => {
      if (event?.status === "processing") {
        context.setProgress({ status: PROCESS_STATUS.PROCESSING, message: "Generating SOW analysis..." });
        return true;
      }
      return false;
    },
  });

  context.setCorrelationId(correlationId);
  return {
    correlationId,
    payload,
  };
}
